import { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router";
import "./formAdress.scss";
import { GetlifeContext } from "../../../context/GetLifeContext.context";
import HttpLeadRepository from "../../../api/request/Lead/Lead.service";
import { I18nContext } from "../../../context/i18n.context";
import { AutoCompleteGoogle, ButtonDS, PredictiveSearch, TextInput } from "get-life-storybook-ts";
import {
  validateZipCodeFR,
  validationsGlobal,
} from "../../../utils/validations";
import { GlobalDomainAutoCompleteGoogle, GlobalProvinceApi } from "../../../utils/InternationlChanges";
import { StatusContext } from "../../../context/StatusContext";
import { DOMAIN } from "../../../constants/Global";
import {
  trackQuestionAnswered,
  trackSubmissionError,
  trackValidationError,
} from "../../../helpers/Tracking";
import { createValidationErrorTracker } from "../../../helpers/Tracking/useTrackValidationErrors";
import {
  residentialZipCityMessage,
  residentialZipCityRejection,
} from "../../../native/residentialZipCity";

export default function FormAdress(props) {
  const { setLoading, token, leadId } =
    useContext(GetlifeContext);
  const navigate = useNavigate();
  const [first, setFirst] = useState(true);
  const [address, setAddress] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [province, setProvince] = useState("");
  const [provinceList, setProvinceList] = useState([]);
  const [city, setCity] = useState("");
  const [number, setNumber] = useState("");
  const [error, setError] = useState({});
  const [errorMessage, setErrorMessage] = useState({});
  const [disabled, setDisabled] = useState({
    address: true,
    zipCode: true,
    province: true,
    city: true,
    number: true
  });

  const {
    state: { translate },
  } = useContext(I18nContext);

  const { getStatus } = useContext(StatusContext);

  const leadRepository = new HttpLeadRepository(leadId, token);
  const LOCALE = process.env.REACT_APP_DOMAIN_LOCALE;

  useEffect(() => {
    setLoading(true);

    leadRepository.getCheckoutData().then((data) => {
      if (data.code === 401) {
        navigate("/login");
      } else {
        data.lead.city && setCity(data.lead.city);
        data.lead.province && setProvince(data.lead.province);
        data.lead.zipcode && setZipCode(data.lead.zipcode);
        fetchRegionalData(data.lead.zipcode);
        data.lead.addressLine && setAddress(data.lead.addressLine);
      }
    });
    setLoading(false);
    getStatus(true);
  }, []);

  // Errores de formato de código postal, provincia y ciudad (telemetría v3).
  const trackFormatErrors = useRef(createValidationErrorTracker("format")).current;

  // El aviso de CAP de otro comune se retira si el cliente cambia el comune (el
  // CAP puede ser el bueno); si cambia el CAP, lo retira la validación del campo.
  const zipCityRejected = useRef(false);
  useEffect(() => {
    if (!zipCityRejected.current) return;
    zipCityRejected.current = false;
    setError((previous) => ({ ...previous, zipCode: { error: false, message: "" } }));
  }, [city]);

  const sendAnswerFormAddress = async () => {
    const data = {
      addressLine: address,
      province: DOMAIN !== "it" ? province : null,
      city: city,
      zipcode: parseInt(zipCode),
      number: DOMAIN === "it" ? number : null
    };

    await leadRepository.saveData(data).then((res) => {
      trackQuestionAnswered("adress", "postpayment");
      if (DOMAIN === "it") {
        navigate("/beneficiary");
      } else {
        navigate(`/coverage/2`);
      }
    }).catch((e) => {
      // Native IT: CAP de otro comune (422 INVALID_RESIDENTIAL_ZIP_CITY). Se dice en el
      // campo del CAP con el CAP válido del comune, en vez de que AGL rechace la
      // propuesta al aceptar la nota legal.
      const zipCity = residentialZipCityRejection(e);
      if (null !== zipCity) {
        trackValidationError("zipCode", "api");
        const cityName =
          provinceList.find((option) => String(option.value) === String(city))?.text ?? null;
        zipCityRejected.current = true;
        setError({
          zipCode: {
            error: true,
            message: residentialZipCityMessage(translate, zipCity, String(zipCode), cityName),
          },
        });
        return;
      }
      if (e.status !== 400) {
        trackSubmissionError(e);
      }
      if (e.status === 400) {
        trackValidationError("zipCode", "api");
        let errorZipCode = {
          error: true,
          message: translate("error.notZipCode")
        }
        setError({
          zipCode: errorZipCode
        });
      }
    });
  };

  const validationsChecks = {
    zipCode: [
      (value) =>
        validationsGlobal({
          value,
          setDisabled,
          disabledData: disabled,
          translate,
          field: "zipCode",
          exactly: 5,
        }),
    ],
    province: [
      (value) =>
        validationsGlobal({
          basic: true,
          disabledData: disabled,
          field: "province",
          setDisabled,
          translate,
          value,
        }),
    ],
    city: [
      (value) =>
        validationsGlobal({
          basic: true,
          disabledData: disabled,
          field: "city",
          setDisabled,
          translate,
          value,
        }),
    ],
    number: [
      (value) => 
      DOMAIN === "it" && validationsGlobal({
        basic: DOMAIN === "it" ? true : false,
        disabledData: disabled,
        field: "number",
        setDisabled,
        translate,
        value,
      })
    ]
  };

  useEffect(() => {
    setLoading(true);
    leadRepository.getQuestionNomenclator(GlobalProvinceApi[LOCALE]).then((res) => {
      const { answers } = res;
      setProvinceList([...answers]);
    });
    setLoading(false);
  }, []);

  const fetchRegionalData = async (zipCode) => {
    if (zipCode && DOMAIN !== "it") {
      try {
        const dataRes = await leadRepository.getRegionalData(zipCode);
        setProvince(dataRes.province);
        setCity(dataRes.city);
      } catch (error) { }
    }
  };

  const fetchZipCodeItaly = async (zipCode) => {
      try {
        const dataRes = await leadRepository.getCityFromZipCode(zipCode);
        if (dataRes.length !== 0) {
          setProvinceList([...dataRes]);
          setCity(dataRes[0].value);
          setDisabled({
            address: !address,
            province: !province,
            city: !dataRes[0].value,
            zipCode: !zipCode,
          });
        } else {
          setDisabled({
            address: !address,
            province: !province,
            city: !city,
            zipCode: true,
          });
          trackValidationError("zipCode", "api");
          setError({ ...error, zipCode: {
            error: true,
            message: translate("error.notZipCode")
          } });
        }
        
      } catch (error) { }
  };

  const fetchRegionalDataFR = async () => {
    let response;
    try {
      const res = await validateZipCodeFR({
        value: zipCode,
        errorGlobal: error,
        translate,
      });
      if (!res.error) {
        await fetchRegionalData();
      }
      response = res;
    } catch (error) { }

    if (response?.error) trackValidationError("zipCode", "api");
    setError({ ...error, zipCode: response });
    setDisabled({
      address: !address,
      province: !province,
      city: !city,
      zipCode: response.error,
    });
  };

  useEffect(() => {
    (async () => {
      if (zipCode && zipCode.length > 4) {
        if (DOMAIN === "fr") {
          await fetchRegionalDataFR();
        } else if ( DOMAIN === "it") {
          await fetchZipCodeItaly(zipCode)
        } else {
          await fetchRegionalData(zipCode);
        }
      }
    })();
  }, [zipCode]);

  useEffect(() => {
    if (!first) {
      const errorZipCode = validationsChecks.zipCode[0](zipCode);
      const errorProvince = validationsChecks.province[0](province);
      const errorCity = validationsChecks.city[0](city);
      const errorNumber = validationsChecks.number[0](number);

      setError({
        zipCode: errorZipCode,
        province: errorProvince,
        city: errorCity,
      });
      trackFormatErrors({
        zipCode: errorZipCode,
        province: errorProvince,
        city: errorCity,
      });

      setDisabled({
        ...disabled,
        address: !address,
        zipCode: errorZipCode.error,
        province: errorProvince.error,
        city: errorCity.error,
        number: DOMAIN === "it" ? errorNumber.error : false
      });
    }
    setFirst(false);
  }, [address]);

  return (
    <div className="formAdress-container">
      <div className="formAdress-GridContainer">
        <div className="row">
          <AutoCompleteGoogle
            initialVal={address}
            name={"address"}
            label={translate("dashboard.profile.address")}
            handleAddress={setAddress}
            handleZipCode={DOMAIN !== "it" ? setZipCode : () => null}
            handleProvince={setProvince}
            handleNumber={setNumber}
            handleCity={DOMAIN !== "it" ? setCity : () => null}
            error={error.address}
            errorMessage={errorMessage.address}
            translate={translate}
            DOMAIN={GlobalDomainAutoCompleteGoogle[DOMAIN]}
          />
        </div>

        <div className="row">
          {DOMAIN !== "it" ? (
            <PredictiveSearch
              initialValue={province}
              onValueChange={setProvince}
              options={provinceList}
              initialError={error.province}
              label={translate("dashboard.profile.province")}
              placeholder={translate("dashboard.profile.province.placeholder")}
              validationChecks={validationsChecks.province}
            />
          ) : (
            <TextInput
              initialValue={number}
              label={translate("aggregator.personalInformation.number")}
              placeholder={translate(
                "aggregator.personalInformation.number.placeHolder"
              )}
              onValueChange={setNumber}
              initialError={error.number}
              validationChecks={validationsChecks.number}
            />
          )}
          <TextInput
            initialValue={zipCode}
            label={translate("aggregator.personalInformation.cp")}
            placeholder={translate(
              "aggregator.personalInformation.cp.placeHolder"
            )}
            onValueChange={setZipCode}
            initialError={error.zipCode}
            validationChecks={validationsChecks.zipCode}
          />
        </div>

        <div className="row">
          {
            DOMAIN === "it" ? (
              <PredictiveSearch
                initialValue={city}
                onValueChange={setCity}
                options={provinceList}
                initialError={error.city}
                label={translate("dashboard.profile.city")}
                placeholder={translate("dashboard.profile.city.placeholder")}
                validationChecks={validationsChecks.city}
                sortOptionsByValue={true}
              />
            ) : (
              <TextInput
                initialValue={city}
                label={translate("dashboard.profile.city")}
                placeholder={translate("dashboard.profile.city.placeholder")}
                onValueChange={setCity}
                initialError={error.city}
                validationChecks={validationsChecks.city}
              />
            )
          }

        </div>

        <div className="formAdress-buttonContainer">
          <ButtonDS
            label={translate("continuar")}
            onClick={sendAnswerFormAddress}
            disabled={!Object.values(disabled).every((item) => item === false)}
          />
        </div>
      </div>
    </div>
  );
}
